import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { orderBy } from 'lodash';

import { MOD_VERSION_STATUS, MOD_VERSION_COMMENT_TYPES } from '../../../utils/constants';
import { formatDateTime } from '../../../utils/formatting';

import Remove from '../../Remove/Remove';
import Reject from '../../Reject/Reject';
import Reinstall from '../../Reinstall/Reinstall';
import Caption from '../../Caption/Caption';
import Checkbox from '../../Checkbox/Checkbox';
import EditLabelText from '../EditLabelText/EditLabelText';
import ModState from '../../ModState/ModState';
import Notification from '../../Notification/Notification';
//import Select from '../../Select/Select';

import {
    EDIT_UPLOAD_UPDATE_LIST_ALL_UPDATE_LABEL,
    EDIT_UPLOAD_UPDATE_LIST_ALL_UPDATE_TEXT,
    EDIT_UPLOAD_UPDATE_LIST_GAME_VERSION_VALUE,
    EDIT_UPLOAD_UPDATE_LIST_UPLOADED_AT_VALUE,
    EDIT_UPLOAD_UPDATE_LIST_STATE_CAPTION,
} from './translations';

import styles from './EditUploadUpdateList.module.css';
import { getUserRole } from '../../../utils/functions';


export default class EditUploadUpdateList extends React.Component {
    static propTypes = {
        modId: PropTypes.number,
        title: PropTypes.string,
        comments: PropTypes.arrayOf(PropTypes.shape({
            authorName: PropTypes.string,
            content: PropTypes.string.isRequired,
            createdAt: PropTypes.string.isRequired,
            gameVersion: PropTypes.string,
            modVersion: PropTypes.string,
            modVersionId: PropTypes.number,
            status: PropTypes.string,
        })).isRequired,
        versions: PropTypes.arrayOf(PropTypes.shape({
            createdAt: PropTypes.string.isRequired,
            gameVersion: PropTypes.string.isRequired,
            id: PropTypes.number.isRequired,
            isVisible: PropTypes.bool.isRequired,
            modVersion: PropTypes.string.isRequired,
            status: PropTypes.number.isRequired,
        })).isRequired,

        onModVersionRemove: PropTypes.func.isRequired,
        onModVersionReject: PropTypes.func,
        onDownloadClick: PropTypes.func,
        onModVersionVisibilityChange: PropTypes.func.isRequired,
        onOpenDialogChangeGameVersionMod: PropTypes.func,
    }

    constructor() {
        super()

        this.state = {
            gameVersionId: null,
            gameVersion: null,
        }
    }

    componentDidMount() {
        /*const selectedVersion = this.props.versions.find((item) => (item.id === this.props.selectedModVersionId))
        this.setState({
            gameVersionId: this.props.gameVersionId,
            gameVersion: selectedVersion.gameVersion,
        })*/
    }

    handleVersionVisibilityChange = (modVersionId) => {
        this.props.onModVersionVisibilityChange(modVersionId)
    }

    handleDownloadClick = (selectedModVersionId) => {
        this.props.onDownloadClick(
            true, this.props.modId, this.props.title, this.props.versions, true, selectedModVersionId
        ) // this.props.isModDownloadAccepted   number   string     array    isReview
    }

    sliceText = (text, slicer = 10) => {
        let sliced = text;
        if (text) {
            if (text.length > slicer) {
                sliced = text.slice(0, slicer)+'...';
            }
        }

        return sliced;
    }

    handleGameVersionChange = (gameVersionId, gameVersionItems) => {
        /*const selectedVersion = gameVersionItems.find((item) => (item.value === gameVersionId))
        this.setState({
            gameVersionId,
            gameVersion: selectedVersion.caption,
        })*/
    }
    getMainGameVersion(gameVersionId, gameVersionItems) {
        const selectedValue = gameVersionId

        if (selectedValue) {
            return `МТ ${gameVersionItems.find(item => (item.value === selectedValue)).caption}`
        }

        return ''
    }

    renderGameVersionSelect(numberOfPublishedVersions, index, item, gameVersionItems) {
        return getUserRole() === "user" 
            ? <div className={classNames(styles.td, styles['td__game-version'])} id="game_version" data-tooltip="game_version" title='Версия игры'>
                {EDIT_UPLOAD_UPDATE_LIST_GAME_VERSION_VALUE(item.gameVersion)}
            </div> : 
            <div className={styles.select} title="Изменить" onClick={() => this.props.onOpenDialogChangeGameVersionMod(item.gameVersionId, gameVersionItems, this.props.modId, item.id)}>
                {this.getMainGameVersion(item.gameVersionId, gameVersionItems)}
                {/* <Select
                    items={gameVersionItems}
                    selectedValue={item.gameVersionId} // this.state.gameVersionId
                    onItemChange={(selectedGameVersionId) => this.handleGameVersionChange(selectedGameVersionId, gameVersionItems)}
                    isDisabled={gameVersionItems.length === 1}
                    zIndex={numberOfPublishedVersions-index}
                /> */}
            </div>
    }

    renderItems() {
        const numberOfPublishedVersions = this.props.versions.filter(
            (item) => item.status === MOD_VERSION_STATUS.PUBLISHED,
        ).length

        const numberOfPublishedAndVisibleVersions = this.props.versions.filter(
            (item) => item.status === MOD_VERSION_STATUS.PUBLISHED && item.isVisible,
        ).length

        const isLastPublishedVersion = (item) =>
            this.props.versions.length === 1 ||
            (item.status === MOD_VERSION_STATUS.PUBLISHED && numberOfPublishedVersions === 1) ||
            (item.isVisible && item.status === MOD_VERSION_STATUS.PUBLISHED && numberOfPublishedAndVisibleVersions === 1)

        return orderBy(this.props.versions, 'id', 'desc').map((item, index) => {
            const commentWithRejection = this.props.comments.find(
                (comment) => comment.modVersionId === item.id && comment.status === MOD_VERSION_COMMENT_TYPES.REJECTED,
            )

            const isDisabled = item.status === MOD_VERSION_STATUS.REJECTED || isLastPublishedVersion(item)

            let statuses = [0, 2]

            const gameVersionItems = window.__SETTINGS__.unreleasedGameVersions.map((item) => ({
                value: item.id,
                caption: item.version,
            }))

            return (
                <div className={styles.tr} key={`mod-update-item-${index}`}>
                    <div className={styles.inner}>
                        <div className={classNames(styles.td, styles['td__mod-version'])} id="mod_version" data-tooltip="mod_version" title={`Версия мода: ${item.modVersion}`}>
                            <Checkbox
                                caption={this.sliceText(item.modVersion, 17)}
                                isChecked={item.isVisible}
                                isDisabled={isDisabled}
                                onChange={() => {this.props.onModVersionVisibilityChange(item.id, !item.isVisible)}}
                            />
                        </div>
                        {this.renderGameVersionSelect(numberOfPublishedVersions, index, item, gameVersionItems)}
                        {window.location.pathname.includes('/review/') ? 
                            <div className={classNames(styles.td, styles['td__uploaded-at'])} title="Дата загрузки">
                            {EDIT_UPLOAD_UPDATE_LIST_UPLOADED_AT_VALUE(formatDateTime(item.createdAt))}
                        </div> : null}
                        <div className={classNames(styles.td, styles['td__state'])}>
                            {EDIT_UPLOAD_UPDATE_LIST_STATE_CAPTION()}
                                <ModState state={item.status} target="modVersion" />,
                        </div>
                        {document.location.pathname.includes('/review/') && item.status !== 2 && (
                            <div className={classNames(styles.td, styles['td__reject'])} title="Отклонить">
                                <Reject onClick={() => {this.props.onModVersionReject(item.id)}} />
                            </div>
                        )}
                        {document.location.pathname.includes('/review/') && statuses.includes(item.status) && (
                            <div className={classNames(styles.td, styles['td__publish'])} title="Опубликовать">
                                <Reject onClick={() => {this.props.onModVersionPublish(item.id)}} isPublish={true} />
                            </div>
                        )}
                        {!isLastPublishedVersion(item) && (
                            <div className={classNames(styles.td, styles['td__remove'])} title="Удалить">
                                <Remove onClick={() => {this.props.onModVersionRemove(item.id)}} />
                            </div>
                        )}
                        {document.location.pathname.includes('/review/') && (
                            <div className={classNames(styles.td, styles['td__install'])} title="Скачать">
                                <Reinstall onClick={() => {this.handleDownloadClick(item.id)}} />
                            </div>
                        )}
                    </div>

                    {index === 0 && commentWithRejection && (
                        <div className={styles.notification}>
                            <Notification type="warning">
                                <p>{commentWithRejection.content}</p>
                            </Notification>
                        </div>
                    )}
                </div>
            )
        })
    }

    render() {
        return (
            <div className={styles.base}>
                <div className={styles.row}>
                    <div className={styles.label}>
                        <Caption isLarge>
                            {EDIT_UPLOAD_UPDATE_LIST_ALL_UPDATE_LABEL}
                        </Caption>
                        <EditLabelText message={EDIT_UPLOAD_UPDATE_LIST_ALL_UPDATE_TEXT} />
                    </div>
                    <div className={styles.field}>
                        <div className={styles.table}>
                            {this.renderItems()}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
